import React from 'react';
import ReactQuill from 'react-quill';
import styled from 'styled-components';

interface QuillWrapperProps {
  value?: string;
  onChange?: (value: string) => void;
}

const QuillWrapper: React.FC<QuillWrapperProps> = ({ value, onChange }) => {
  return (
    <StyledReactQuill
      theme='snow'
      value={value || ''}
      onChange={onChange}
      modules={{
        toolbar: [
          [{ header: [1, 2, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link', 'image'],
          ['code-block', 'blockquote'],
          [{ align: [] }],
          ['clean'],
        ],
      }}
      formats={[
        'header',
        'bold',
        'italic',
        'underline',
        'strike',
        'list',
        'bullet',
        'link',
        'image',
        'code-block',
        'blockquote',
        'align',
      ]}
      placeholder='Please enter...'
    />
  );
};

export default QuillWrapper;

const StyledReactQuill = styled(ReactQuill)`
  .ql-container {
    min-height: 400px;
    font-family: Poppins;
    font-size: 14px;
    border: 1px solid #d9d9d9;
    border-radius: 0 0 4px 4px;
  }

  .ql-editor {
    min-height: 400px;
  }

  .ql-toolbar {
    background: #fafafa;
    border: 1px solid #d9d9d9;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .ql-editor.ql-blank::before {
    color: #bfbfbf;
    font-style: normal;
  }
`;

// Custom wrapper component for ReactQuill to work with Form.Item
